<template>
  <div class="featureFlag">
    
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet class="ma-2 pa-2">
          <v-breadcrumbs :items="[ { text: $t('featureFlag'), disabled: true, href: '/' } ]"></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet class="ma-2 pa-2">
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_STAFF_ADMIN')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_feature") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-row>
          <v-col cols="4">
            <!-- <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details></v-text-field> -->
          </v-col>
          <v-col cols="4">
            <!-- <vue-json-to-csv :json-data="this.acquirer.data" :csv-title="acquirerList">
                <v-btn color="success" class="mr-6">
                    Export <i class="mdi mdi-export-variant" aria-hidden="true"></i>
                </v-btn>
            </vue-json-to-csv>                                               -->
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="featureFlag"
        class="elevation-1 custom-table-style"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.enabled="{ item }">
          {{ item.raw.enabled ? 'Enabled' : 'Disabled' }}
        </template>
        <template v-slot:item.actions="{ item }">          
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_STAFF_USER') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_STAFF_USER') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>

        <!-- Loading Slot -->
      </v-data-table>
    </v-card>

    <!-- ADD FEATURE DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form ref="addFeature" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_feature") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                                                 
                    <v-text-field
                      :label="$t('Feature name')"
                      :rules="[required, validateName]"
                      clearable
                      v-model="feature_data.f_feature_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('barcode')"
                      v-model="feature_data.f_barcode"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                        :items= "organizations"
                        item-title="name"
                        item-value="id"
                        :label="$t('Select organization')"                          
                        :rules="[required]"
                        v-model="feature_data.f_organization"
                    ></v-select>                
                  </v-col>
                </v-row>
              </v-container>
              <small>* {{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addFeature"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD FEATURE DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("Update Feature") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                                                 
                    <v-text-field
                      :label="$t('Feature name')"
                      :rules="[required, validateName]"                      
                      v-model="feature_data.f_feature_name"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('barcode')"
                      v-model="feature_data.f_barcode"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                        :items= "organizations"
                        item-title="name"
                        item-value="id"
                        :label="$t('Select organization')"                          
                        :rules="[required]"
                        v-model="feature_data.f_organization"
                        readonly
                    ></v-select>                
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="dialog_update = false"
              >
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateFeature"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- DELETE DIALOG -->
   
    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteFeature">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE FEATURE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FeatureFlag",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      featureFlag: [],      
      organizations: [],
      
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      first_response: [],
      second_response: [],
      
      feature_data: {
        f_feature_name: "",
        f_barcode: "",
        f_organization: "",
        createdBy: "",
        updatedBy: "",
      },

      featureId: "",
      feature_response: [],
      search: "",
      selectedCountryName: '',
      headers: [
        {
          title: "Id",
          align: "start",
          sortable: false,
          key: "id",
        },
        { title: this.$t("Name"), key: "featureName" },
        { title: this.$t("Status"), key: "enabled" },
        { title: this.$t("Organization"), key: "organization.orgName" },
        
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //form
      form: false,
      loading: true,
      email_exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },

    /* dynamicLabel() {
      // Show 'Select Merchant' + Merchant Name only when a merchant is selected
      return this.selectedCountryName
        ? `${this.$t('selected_country')} - ${this.selectedCountryName}`
        : this.$t('Select Country');
    }, */
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    /* search(newSearch) {
      if (newSearch.length >= 2) {
        this.searchCountry(newSearch);
      } else {
        this.countries = [];
      }
    }, */

    // Watch the f_merchantId and update the selected merchant name
    /* 'acquirer_data.f_country'(newcountries) {
      const selectedCountry = this.countries.find(
        (country) => country.countryCode === newcountries
      );
      // Update the selectedMerchantName when a new merchant is selected
      this.selectedCountryName = selectedCountry ? selectedCountry.countryName : '';
    }, */
  },
  methods: {
    close() {
      this.feature_data.f_feature_name = "";
      this.feature_data.f_organization = "";
      this.dialog = false;
    },

    validateAcquirerName(value) {
      const regex = /^[A-Za-z0-9_ ]+$/;
      return (
        regex.test(value) ||
        "Name can only contain letters, numbers, and underscores."
      );
    },

    resetInput() {
      this.feature_data.f_feature_name = "";
      this.feature_data.f_barcode = "";
      this.feature_data.f_organization = "";
      this.feature_data.createdBy = "";
      this.feature_data.updatedBy = "";
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.requests_handler()
    },

    compose_update(id) {
      this.featureId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.featureId = id;
      this.dialog_delete = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler() {
      //second method
      axios
        .all([
          axios.get(window.baseurl + "organizations", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((first_response) => {
            // console.log("data1", first_response.data);

            //if response data is an array // handle it as below
            if (first_response.status == 200) {
              if (
                first_response.data.records != null &&
                first_response.data.records.length > 0
              ) {
                let i = 0;
                this.organizations = []; //remove all items from array
                for (i = 0; i < first_response.data.records.length; i++) {                  
                  this.organizations.push({
                    id: first_response.data.records[i].id,
                    name: first_response.data.records[i].orgName,
                  });
                  //console.log("countries", this.countries)
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addFeature() {
      //this.dialog = false
      // console.log("form data", this.acquirer_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "featureFlags",
          {
            featureName: this.feature_data.f_feature_name,
            enabled: this.feature_data.f_barcode,
            organizationId:this.feature_data.f_organization,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
           
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({ message: this.$t("feature_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        // console.warn("error", error.response.data.error);
        //this.show_toast(true, "warning", error.response.data.message);
        if (error.response.status === 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else if (error.response.status === 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.error });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "featureFlags/" + "" + this.featureId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl+"organizations" , {"headers": {'Authorization': 'Bearer ' + this.accessToken} })
        ])
        .then(
          axios.spread((first_response, second_response) => {
            console.log("data1", first_response.data);
            console.log("data2", second_response.data)

            //get acquirer data for selected id and display data in for dialog
            if (first_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("acquirer Data", this.acquirer_response);
              this.feature_data.f_feature_name = first_response.data.featureName;                
              this.feature_data.f_barcode = first_response.data.enabled;
              this.feature_data.f_organization = first_response.data.organization.id;                
              
            }

            
            if(second_response.status == 200){   
                if(second_response.data.records != null && second_response.data.records.length > 0){
                    let i = 0;
                     this.organizations = [];   //remove all items from array
                    for(i=0; i<second_response.data.records.length; i++){                                                  
                        this.organizations.push({ id: second_response.data.records[i].id, name: second_response.data.records[i].orgName });                         
                       
                    }                    
                }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateFeature() {
     // this.dialog_update = false;
      this.checkTokenExpiry();
      try {
        // console.log("update form acquirer id", this.acquirerId);
        // console.log("update form acquirer", this.acquirer_data);
        let result = await axios.put(
          window.baseurl + "featureFlags/" + "" + this.featureId,
          {
            featureName: this.feature_data.f_feature_name,
            enabled: this.feature_data.f_barcode,
            organizationId:this.feature_data.f_organization,
            updatedBy: this.userEmail,
            
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form acquirer result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("feature_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        // console.log("error", error);
        if (error.response.status === 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else if (error.response.status === 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.error });
        }
      }
    },

    async deleteFeature() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "featureFlags/" + this.featureId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form acquirer result", result)
        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("feature_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.response.data.message);
        this.$root.vtoast.showError({ message: error.response.data.error });
      }
    },

    async fetchData() {
      this.loading = true;
      let page2 = this.page - 1;
      let result;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "featureFlags", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          console.log("feature_object", result);
          this.featureFlag = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } 
      } catch (error) {
        //this.show_toast(true, "warning", error.response.data.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
        // console.log("error", error.response.data.message);
      }
    },
  
    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "featureFlags/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("acquirer_object", result);
          this.featureFlag = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
        }        
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },
        

    validateName(value) {
      const regex = /^[A-Za-z0-9&#'()-._ ]+$/;
      return (
        regex.test(value) ||
        "Name can only contain numbers, letters, spaces, underscores, hyphens,() . _"
  );
    },

  },
  //get list of features
  async mounted() {
    this.checkTokenExpiry();
    //console.log("org", this.orgId);
    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search_row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
